import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { BIG_MARGIN, MIDDLE_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        marginLeft: MIDDLE_MARGIN,
      },
      [theme.breakpoints.up('lg')]: {
        marginLeft: BIG_MARGIN,
      },
    },
  }),
);
export default useStyles;
